import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import { useDispatch } from 'react-redux'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { MagicViewContent } from '../email-settings'
const TeamsMemberListHeader = props => {
  const { classes } = props
  const dispatch = useDispatch()

  const handleEmailSettings = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          component: <MagicViewContent />,
          title: `
          <div
            style="
              display: flex;
              align-items: center;
            "
          >
            <Typography
              style="
                font-size: 16px;
                font-weight: 600;
              "
            >
              Send email
            </Typography>
          </div>
            `,
        }),
      ),
    )
  }
  return (
    <div className={classes.page__header__title}>
      <img
        alt="invite-learners"
        src="/assets/invite-learners.png"
        height={40}
        width={40}
      />
      <div className={classes.inviteTexts}>
        <Typography className={classes.inviteLearners}>
          Invite learners
        </Typography>
        <Typography className={classes.inviteLearnersDescription}>
          Customize and send the learners' access invitation email
        </Typography>
      </div>
      <CoreButton color="success" onClick={() => handleEmailSettings()}>
        Send email
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(TeamsMemberListHeader)
